// Die zwei Ausweich-Zustaende der Projektseite.
//
// WOFUER: nur herausgeloest, damit `routes/Project.tsx` unter 500 Zeilen
// bleibt. `ProjectNotFound` gilt fuer eine unbrauchbare Route-Id (/p/abc),
// `ProjectError` fuer ein Projekt, das der Server nicht liefert.
//
// `ProjectError` traegt bewusst ein `h2`, KEIN `h1`: es rendert innerhalb des
// Layouts, und die App-Kopfzeile haelt dort schon die einzige `<h1>` der Seite
// (`usePageHeader` laeuft in Project.tsx vor den Abbruch-Rueckgaben). Ein
// zweites `h1` waere genau der Fehler, den das Redesign abstellt.
// `ProjectNotFound` dagegen wird gerendert, OHNE dass eine Route den Kopf
// gefuellt hat — dort ist das `h1` die einzige und richtige Ueberschrift.

import { Link, useLocation } from "wouter-preact";
import { Layout } from "../../components/Layout";
import { PageShell } from "../../components/ui/PageShell";

export function ProjectNotFound(): preact.JSX.Element {
  return (
    <Layout>
      <main class="flex min-h-dvh flex-col items-center justify-center gap-3 p-8 text-center">
        <p class="text-xs font-semibold uppercase tracking-widest text-[color:var(--color-primary)]">404</p>
        <h1 class="text-xl font-bold text-[color:var(--color-on-surface)]">Projekt nicht gefunden</h1>
        <Link href="/projects" class="text-sm text-[color:var(--color-primary)] hover:underline">
          Zurück zur Übersicht
        </Link>
      </main>
    </Layout>
  );
}

export function ProjectError(props: { message: string }): preact.JSX.Element {
  const [, setLocation] = useLocation();
  return (
    <PageShell width="default">
      <div class="flex flex-col items-center justify-center gap-3 py-16 text-center">
        <h2 class="text-xl font-bold text-[color:var(--color-error)]">
          Fehler beim Laden
        </h2>
        <p class="text-sm text-[color:var(--color-on-surface-variant)]">{props.message}</p>
        <button
          type="button"
          onClick={() => setLocation("/projects")}
          class="min-h-[32px] rounded border border-[color:var(--color-outline-variant)] bg-[color:var(--color-surface-container-lowest)] px-4 py-2 text-sm font-medium text-[color:var(--color-on-surface)] transition-colors hover:bg-[color:var(--color-surface-container-low)]"
        >
          Zurück zur Übersicht
        </button>
      </div>
    </PageShell>
  );
}
